module.exports = __webpack_public_path__ + "img/person2.4cc71de6.png";